module.exports = __webpack_public_path__ + "static/img/introduction-environmental-strategy-science-based-targets.72d4e87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-environmental-strategy-science-based-targets.jpg
// module id = +U6N
// module chunks = 0